// https://kit.svelte.dev/docs/routing#advanced-routing-matching
/** @type {import('@sveltejs/kit').ParamMatcher} */
export function match(param) {
  return /^@.+$/.test(param);
}
